import { AvForm } from 'availity-reactstrap-validation'
import Select from '../../../CMSComponent/Forms/Fields/select'
import { primary_color } from '../../../Helper/uiHelper'
import RoundedSelect from '../../Form/Fields/roundedSelect'

const SelectQueryType = ({ data, formData, setFormData, heading }) => {
  const form = data?.find((item) => item?.component_name === 'form')?.forms?.[0]
  let queryTypeField = form?.component_call_fields?.find((item) => item?.field_id === 'query_type_id')
  queryTypeField = {
    ...queryTypeField,
    place_holder: 'What is your Query?',
  }

  let queryField = form?.component_call_fields?.find((item) => item.field_id === 'query_id')
  queryField = {
    ...queryField,
    place_holder: 'Select Query',
  }

  return (
    <div className='mt-4 content-widget'>
      <h2 className='text-center font-weight-bold mb-5 mt-5' style={{ color: primary_color }}>
        {heading?.replace(/<[^>]*>/g, '')}
      </h2>
      <AvForm>
        <div className='my-4 mt-4'>
          <RoundedSelect
            data={queryTypeField}
            parentRequired={false}
            formData={formData}
            setFormData={setFormData}
            formIndex={0}
            formFieldValue={formData?.[0]}
            hideLabel={true}
            isClearable={true}
          />
        </div>

        {formData?.[0]?.query_type_id && (
          <div className='my-3'>
            {' '}
            <RoundedSelect
              data={queryField}
              parentRequired={false}
              formData={formData}
              setFormData={setFormData}
              formIndex={0}
              formFieldValue={formData?.[0]}
              depend_field_source_table={'query_types'}
              hideLabel={true}
              isClearable={true}
            />
          </div>
        )}
      </AvForm>
    </div>
  )
}

export default SelectQueryType
